module.exports = __webpack_public_path__ + "static/img/how-get-credit-5.347f1cd3.svg";